export default "__VITE_PUBLIC_ASSET__e9595b1b__"